// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

// MODEL USED IN APPLICATION (with additional properties)


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************


// UI enums *********************************************************
export enum CheckEnum {
	ENUM_CHECK_ALL = '[enum] check all',
	ENUM_COMPARE_KEYS = '[enum] compare enum keys',
	ENUM_COMPARE_VALUES = '[enum] compare enum values',
	MODEL_CHECK_ALL = '[model] check all',
	MODEL_NEW_PROPS = '[model] new dto props',
	MODEL_PROPERTY_COUNT = '[model] property count',
	MODEL_REMOVED_PROPS = '[model] removed dto props',
	MODEL_RECURSIVELY_COMPARE_PROPS = 'model recursively compare props',
}
